import React from 'react';

const Demo: React.FC = () => {
  return (
    <div>
      <h1>Welcome</h1>
      <p>Greeting</p>
    </div>
  );
};

export default Demo;
